import { TEST_IDS } from '@va/constants';
import { useTooltipContext } from '@va/ui/tooltips';
import classNames from 'classnames';
import dayjs, { Dayjs } from 'dayjs';
import { useCallback, useMemo } from 'react';
import { useDateInputContext } from './DateInputContext';

export const Calendar = () => {
  const {
    pickerViewState: { year, month },
    pickedDate,
    setPickedDate,
    isDateInRange,
  } = useDateInputContext();
  const { context } = useTooltipContext();

  const calendarDays = useMemo(() => {
    const date = dayjs().year(year).month(month).day(1);

    let currentDate = date.startOf('month').weekday(0);
    const nextMonth = date.add(1, 'month').month();

    let allDates: Dayjs[] = [];
    let weekDates = [];

    let weekCounter = 1;

    while (currentDate.weekday(0).month() !== nextMonth) {
      weekDates.push(currentDate);

      if (weekCounter === 7) {
        allDates = allDates.concat(weekDates);
        weekDates = [];
        weekCounter = 0;
      }

      weekCounter++;
      currentDate = currentDate.add(1, 'day');
    }

    return allDates;
  }, [month, year]);

  const handleDayClick = useCallback(
    (date: Dayjs) => {
      setPickedDate(date);
      context?.onOpenChange(false);
    },
    [context, setPickedDate],
  );

  return (
    <div className='grid grid-cols-7 gap-y-0.5 my-1' data-testid={TEST_IDS.generic.datePicker.daysPanel}>
      {calendarDays.map((date) => {
        const isInMonth = date.month() === month;
        const isSelected = date.isSame(pickedDate, 'day');
        const isDisabled = !isDateInRange(date, 'day');

        return (
          <button
            key={date.toString()}
            type='button'
            className={classNames('w-12 h-12 flex justify-center items-center text-xs rounded-full', {
              'font-light': !isInMonth,
              'font-semibold': isInMonth,
              'bg-primary text-white': isSelected,
              'hover:bg-primary-lighter-10': !isDisabled,
              'cursor-not-allowed opacity-50': isDisabled,
            })}
            disabled={isDisabled}
            onClick={() => handleDayClick(date)}
            data-testid={TEST_IDS.generic.buttons.select}
          >
            {date.date()}
          </button>
        );
      })}
    </div>
  );
};
